var map = {
	"./ATM.svg": "jdhL",
	"./PMS.svg": "wbxW",
	"./agent.svg": "Liw6",
	"./auth.svg": "YbHB",
	"./dashboard.svg": "BCGP",
	"./data-v.svg": "HdcP",
	"./datav.svg": "DtUw",
	"./device.svg": "k6Cd",
	"./example.svg": "OOLB",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./face.svg": "A76F",
	"./firmware.svg": "JA4C",
	"./form.svg": "sTIr",
	"./guest_control.svg": "7B6a",
	"./hamburger.svg": "PHf5",
	"./hotel.svg": "v7F4",
	"./hotel1.svg": "IQaD",
	"./language.svg": "+Dip",
	"./light.svg": "NuOq",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./mail.svg": "CFfD",
	"./operation.svg": "Dh6m",
	"./password.svg": "QjmH",
	"./reminder.svg": "P8zy",
	"./setting.svg": "Kttn",
	"./theme-icon.svg": "fyzk",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 10